import Service, { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type { IntlService } from 'ember-intl'

export type ExternalRosteringSource = 'classlink' | 'clever' | 'wonde' | 'ftp'

export default class ExternalRosteringService extends Service {
  @service session!: SessionService
  @service intl!: IntlService

  // e.g. "ClassLink", "Clever"
  get displayName(): string {
    if (this.source) {
      return this.intl.t(`externalRostering.displayName.${this.source}`)
    }
    return ''
  }

  get isEnabled(): boolean {
    return this.school.usesExternalRostering
  }

  get source(): Nullable<ExternalRosteringSource> | undefined {
    return this.school.externalRosteringSource
  }

  private get school() {
    return this.session.currentSchool
  }
}

declare module '@ember/service' {
  interface Registry {
    'external-rostering': ExternalRosteringService
  }
}
